import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor() { }

    handleError(err: HttpErrorResponse) {
        return throwError(err);
    }
}
